import { defu } from 'defu'

// Always add 'min' and 'navigation' categories
const pressAndMediaDataCategories = new Map([
  ['PagePressAndMedia', ['global-forms', 'global-offices', 'form-labels', 'investor-relations-labels', 'filter-labels']]

])

const pressAndMediaApiEndpoints = new Map([[
  '', ''
]])

export const usePressAndMediaGlobalData = () => {
  const { labels, globalContentData, localeGlobalContentData, setGlobalContentData, generateDataPromisesForContentType } = useGlobalData()
  const pressAndMediaGlobalData = useState('press-media', () => ({}))

  async function fetchGlobalDataForContentType (contentType, locale) {
    const key = contentType + '-' + locale
    if (pressAndMediaGlobalData.value[key]) {
      return
    }
    const promises = generateDataPromisesForContentType(contentType, pressAndMediaDataCategories, pressAndMediaApiEndpoints, locale)
    const responses = await Promise.all(promises)

    let data = {}
    responses.forEach((r: any) => {
      data = defu(r, data)
    })

    setGlobalContentData(data)
    pressAndMediaGlobalData.value[key] = true
  }

  return {
    labels,
    globalContentData,
    localeGlobalContentData,
    fetchGlobalDataForContentType
  }
}
